import Vue from "vue";
import Vuex from "vuex";
import { createFlashStore } from "vuex-flash";
import state from "./state";
import createPersistedState from "vuex-persistedstate";
import * as Cookies from "js-cookie";
import * as getters from "./getters";
import * as mutations from "./mutations";
import auth from "./auth";
import users from "./users";
import trainers from "./trainers";
import schools from "./schools";
import primarySchools from "./primarySchools";
import teachers from "./teachers";
import students from "./students";
import attendance from "./attendance";
import dropouts from "./dropouts";
import feedings from "./feedings";
import parents from "./parents";
import searches from "./searches";
import trackings from "./trackings";
import dashboards from "./dashboards";
import groups from "./groups";
import coordinators from "./coordinators";
import teams from "./teams";
import optionsList from "./optionsList";
import extras from "./extras";
import crumb from "./crumb";
import mio from "./mio";
import dataConsentTrainer from './dataConsentTrainer'
import cluster from './cluster'

Vue.use(Vuex);
Vue.config.devtools = true;

export default new Vuex.Store({
  state,
  getters,
  mutations,
  modules: {
    auth,
    users,
    trainers,
    schools,
    primarySchools,
    teachers,
    students,
    attendance,
    dropouts,
    feedings,
    parents,
    searches,
    trackings,
    dashboards,
    groups,
    coordinators,
    teams,
    optionsList,
    crumb,
    mio,
    extras,
    dataConsentTrainer,
    cluster
  },
  plugins: [createFlashStore()],
  // strict: true
});
